import { render, staticRenderFns } from "./StripeSetupForm.vue?vue&type=template&id=396dfa90&"
import script from "./StripeSetupForm.vue?vue&type=script&lang=js&"
export * from "./StripeSetupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../order-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports